// extracted by mini-css-extract-plugin
module.exports = {"company-group-state-part-item__state-part-type":"Rr4WlsrjodBtBi8v_rU9y","company-group-state-part-item__state-part-share":"JDMFZ-fFI2zvZIjZ5UCxq"};